import React from "react";

import {
Switch
} from "antd";


const Darkmode = ({
darkMode,
setDarkMode
})=>{


return (

<Switch

size="small"

checked={darkMode}

onChange={(value)=>setDarkMode(value)}

checkedChildren="🌙"

uncheckedChildren="☀️"

/>

);


};


export default Darkmode;